module.exports = function(PluginManager) {
  PluginManager.registerDependency('sources/platform', require('./sources/platform'));
  PluginManager.registerVisitorProfileProvider(require('./providers/platform'));
  PluginManager.registerAudienceMatcher('platform', require('./matchers/platform'));
};
